// 컨설팅 페이지 카피 (90분 · 400,000원)
export const consultingCopy = {
  eyebrow: 'Consulting',
  title: '컨설팅 신청',
  lede:
    '일본 학부 입시 루트를 90분 동안 정리합니다. 합격 보장이 아니라, 요강 기준으로 다음 행동을 정하는 세션입니다.',
  priceLabel: '90분 · 400,000원',
  priceNote:
    '결제: PayPal 또는 계좌 이체. 일정 확정 후 메일로 안내합니다. 사이트에 계좌번호는 올리지 않습니다.',
  capacityNote:
    '월 컨설팅은 소수만 받습니다. 해당 월 일정이 가득하면 대기 등록 또는 다음 달 일정을 제안합니다. 비수기에는 회신이 더 빠를 수 있습니다.',
  includes: [
    '목표(EJU·일반·국비)와 현재 준비 상태 진단',
    '관심 대학 모집요항 1~2개 기준 체크포인트 리뷰',
    '향후 약 90일 액션(시험·서류·일정) 정리',
    '세션 후 요약 메모(핵심만)',
  ],
  excludes: [
    '대리 원서·번역·공증 대행',
    '무기한 카톡/메일 Q&A',
    '합격·장학금 수혜 보장',
    '대학·대사관에 대한 대리 문의',
  ],
  prepare: [
    '목표 대학·학부 후보 (없어도 탐색 가능)',
    '가능하면 해당 연도 모집요항 PDF 링크',
    'EJU/일본어/영어 성적 또는 준비 현황',
    '궁금한 점 3가지',
  ],
  process: [
    '아래 양식 제출 (또는 완성 문구 복사 후 메일)',
    '2~3영업일 내 메일로 가능 일정 제안',
    '일정 확정 후 PayPal 또는 계좌 이체 안내 → 결제 확인 후 세션 링크',
  ],
  policy: [
    '결제 후 · 세션 48시간 전까지 취소: 전액 환불 검토',
    '48시간 이내 취소·노쇼: 원칙 환불 불가 (운영자 귀책·불가항력은 예외 검토)',
    '일정 변경: 세션 48시간 전까지 1회 협의 가능',
    '세션 완료 후 환불 불가',
  ],
  formIntro:
    '신청은 예약 확정이 아닙니다. 「신청 보내기」로 전달하거나, 미리보기 문구를 복사해 메일로 보내도 됩니다. 사전 스크리닝 항목은 세션 적합성을 보기 위한 것입니다.',
  disclaimer:
    '안내는 참고용입니다. 지원 자격·과목·일정은 대학·대사관·시험 기관의 최신 원문을 기준으로 하세요.',
};
